// import A from '../../comps/A';
import B from '../../comps/B';
import C from '../../comps/C';
import D from '../../comps/D';
import E from '../../comps/E';
import F from '../../comps/F';
import G from '../../comps/G';
import H from '../../comps/H';
import I from '../../comps/I';
import J from '../../comps/J';
import K from '../../comps/K';
import L from '../../comps/L';
import M from '../../comps/M';
import N from '../../comps/N';
import O from '../../comps/O';
import EcoSpace from 'eco-design/base/eco-space';
import Energy from '../../comps/Energy';
import Compact from '../../comps/Compact';
import Technology from '../../comps/Technology';
import Weather from '../../comps/Weather';
import Masterpiece from '../../comps/Masterpiece';
import Output from '../../comps/Output';
import Protecting from '../../comps/Protecting';
import FooterTcA from '../../comps/FooterTcA';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import A2 from '../../comps/A2';
import A3 from '../../comps/A3';
import { useRouter } from 'next/router';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { TimelineMax, TweenMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import B2 from '../../comps/B2';
import PageNavLeft from './PageNavLeft';
import { useLang } from '@/app/utils/useLang';

const Overview: React.FC = () => {
    const { locale = '' } = useRouter();
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }
    if (typeof window !== 'undefined') {
        if (!window?.ScrollMagic) {
            window.ScrollMagic = ScrollMagicFn();
            ScrollMagicPluginGsap(window.ScrollMagic, TweenMax, TimelineMax);
        }
    }

    const { t: tPageNavLeft } = useLang('PageNavLeft');

    if (locale === 'de') {
        return (
            <div className={`rapid-pro-overview ${css.page}`} id="stream-ultra-x">
                {/* <A /> */}
                {['de'].includes(locale) ? <A3 /> : <A2 />}
                {['de'].includes(locale) ? <B2 /> : <B />}
                <C />
                <D />
                <div className="range1">
                    <E />
                </div>
                <F />

                <div className="range2">
                    <G />
                </div>
                <H />
                <div className="range3">
                    <I />
                </div>

                <div className="range4">
                    <J />
                </div>
                <div className="range5">
                    <K />
                </div>
                <L />
                <div className="range6">
                    <M />
                </div>
                <N />
                <O />
                <div className="range7">
                    <Energy />
                </div>
                <Compact />
                <div className="range8">
                    <EcoSpace hPc="160px" hPad="100px" hH5="100px" />

                    <Technology />
                </div>
                <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
                <Weather />
                <Masterpiece />
                <Output />
                <Protecting />

                <FooterTcA />

                {/* 左侧锚点 */}
                <PageNavLeft
                    triggerElement={`#stream-ultra-x`}
                    enterElement="#stream-ultra-x-G"
                    steps={[
                        { text: tPageNavLeft('item1'), href: '#stream-ultra-x-E' },
                        { text: tPageNavLeft('item2'), href: '#stream-ultra-x-G' },
                        { text: tPageNavLeft('item3'), href: '#stream-ultra-x-I-position' },
                        { text: tPageNavLeft('item4'), href: '#stream-ultra-x-J' },
                        { text: tPageNavLeft('item5'), href: '#stream-ultra-x-K' },
                        { text: tPageNavLeft('item6'), href: '#stream-ultra-x-M' },
                        { text: tPageNavLeft('item7'), href: '#stream-ultra-x-Energy' },
                        { text: tPageNavLeft('item8'), href: '#stream-ultra-x-Technology-position' },
                    ]}
                />
            </div>
        );
    }

    return (
        <div className={`rapid-pro-overview ${css.page}`}>
            {/* <A /> */}
            {['de'].includes(locale) ? <A3 /> : <A2 />}
            {['de'].includes(locale) ? <B2 /> : <B />}
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
            <M />
            <N />
            <O />
            <Energy />
            <Compact />
            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
            <Technology />
            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
            <Weather />
            <Masterpiece />
            <Output />
            <Protecting />

            <FooterTcA />
        </div>
    );
};

export default Overview;
